import React, { useState } from "react";
import icon from "../../assets/imgs/icon.webp";
import prodigy from "../../assets/imgs/prodigy-logo.webp";
import Modal from "react-bootstrap/Modal";
import Fcontact from "../Shared/Fcontact";
import outlook from "../../assets/imgs/outlook.webp";
import Excel from "../../assets/imgs/Excel.webp";
import Teams from "../../assets/imgs/Teams.webp";
import SharePoint from "../../assets/imgs/SharePoint.webp";
import welathIndicator from "../../assets/imgs/welath-indicator.webp";
import mobileFriendly from "../../assets/imgs/mobile-friendly.webp";
import SuggestedGrantAmount from "../../assets/imgs/Suggested-Grant-Amount.webp";
import AutomatedRecurringGifts from "../../assets/imgs/Automated-Recurring-Gifts.webp";
import AutomatedApprovals from "../../assets/imgs/Automated-Approvals.webp";
import SeamlessGiftGiving from "../../assets/imgs/Seamless-Gift-Giving.webp";
import PledgeManagement from "../../assets/imgs/Pledge-Management.webp";
import ReceiptsAcknowledgements from "../../assets/imgs/Receipts-Acknowledgements.webp";
import AutomaticBackups from "../../assets/imgs/Automatic-Backups.webp";
import HostedonAzure from "../../assets/imgs/Hosted-on-Azure.webp";
import AuthorizedAccessValidation from "../../assets/imgs/Authorized-Access-Validation.webp";
import gdpr from "../../assets/imgs/GDPR.webp";
import HIPPA from "../../assets/imgs/HIPPA.webp";
import PIPEDA from "../../assets/imgs/PIPEDA.webp";
import LevelBasedAccess from "../../assets/imgs/Level-based-Access.webp";
import DedicatedPortals from "../../assets/imgs/Dedicated-Portals.webp";
import DashboardAccessDepartment from "../../assets/imgs/Dashboard-Access.webp";
import VolunteerAccess from "../../assets/imgs/Volunteer-Access.webp";

const ReliabilitySecurity = () => {
  const [show, setShow] = useState(false);
  const [policy, setPolicy] = useState(false);

  const handleClose = () => {
    setPolicy(false);
    setShow(false);
  };

  const AboutFunction = (eleme) => {
    const violation = document.getElementById(eleme);
    window.scrollTo({
      top: violation.offsetTop,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section id="reliablitydiv" className="rseSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 text-center">
              <h3 className="h1">Reliability, Security &amp; Ease of Use</h3>
            </div>
            <div className="col-md-12 col-lg-9 mt-4">
              <div className="d-flex w-100 verticalTabs">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="communication-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#communication"
                      type="button"
                      role="tab"
                      aria-controls="communication"
                      aria-selected="true"
                    >
                      <span className="icon-communication-tab"></span>{" "}
                      Communication &amp; Collaboration
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="operability-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#operability"
                      type="button"
                      role="tab"
                      aria-controls="operability"
                      aria-selected="false"
                    >
                      <span className="icon-operability-tab"></span> Operability
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="scalability-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#scalability"
                      type="button"
                      role="tab"
                      aria-controls="scalability"
                      aria-selected="false"
                    >
                      <span className="icon-scalability-tab"></span> Scalability
                      and Flexibility
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="security-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#security"
                      type="button"
                      role="tab"
                      aria-controls="security"
                      aria-selected="false"
                    >
                      <span className="icon-security-tab"></span> Security
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="compliance-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#compliance"
                      type="button"
                      role="tab"
                      aria-controls="compliance"
                      aria-selected="false"
                    >
                      <span className="icon-compliance-tab"></span> Compliance
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="accessibility-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#accessibility"
                      type="button"
                      role="tab"
                      aria-controls="accessibility"
                      aria-selected="false"
                    >
                      <span className="icon-accessibility-tab"></span>{" "}
                      Accessibility{" "}
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="communication"
                    role="tabpanel"
                    aria-labelledby="communication-tab"
                  >
                    <h3 className="h1">Communication &amp; Collaboration</h3>
                    <p>
                      Segment loyal Donors and Grantmakers and target them with
                      memberships using integrated campaigning capabilities and
                      recognize major donors on the go. Built on CDM(Common Data
                      Model) at its core, Right Cause works seamlessly in
                      Microsoft environment that maintains and streamline
                      scattered donor data to increase donations and revenue,
                      and grow audiences.
                    </p>
                    <p>Available Integrations:</p>
                    <div className="ben-flex-div">
                    <span>
                      <img src={outlook} alt="Outlook" width="126" height="126" />
                      Outlook
                    </span>
                    <span>
                      <img src={Excel} alt="Excel" width="126" height="126" />
                      Excel 
                    </span>
                    <span>
                      <img src={Teams} alt="Teams" width="126" height="126" />
                      Teams
                    </span>
                    <span>
                      <img src={SharePoint} alt="SharePoint" width="126" height="126" />
                      SharePoint 
                    </span>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="operability"
                    role="tabpanel"
                    aria-labelledby="operability-tab"
                  >
                    <h3 className="h1">Operability</h3>
                    <p>
                      Right Cause non-profit CRM software embrace Cloud-first
                      technology and delivers specialist not for profit features
                      that doesn’t require coding at your end. It comes
                      pre-built with custom workflows, process automation and
                      reporting capabilities at its core: Membership &amp;
                      Subscriptions, Learning &amp; Education, CPD, Event
                      Management, Annual Reporting &amp; Appeal, Fundraising and
                      Campaign Management.
                    </p>
                    <p>
                    Use every feature at your disposal to take the hassle out of donating. Adopt easy-to-use innovations, such as:
                    </p>
                    <div className="ben-flex-div">
                    <span>
                      <img src={welathIndicator} alt="Wealth Indicators" width="126" height="126" />
                      Wealth Indicators
                    </span>
                    <span>
                      <img src={mobileFriendly} alt="Mobile-friendly Interfaces" width="126" height="126" />
                      Mobile-friendly Interfaces
                    </span>
                    <span>
                      <img src={SuggestedGrantAmount} alt="Suggested Grant Amount" width="126" height="126" />
                      Suggested Grant Amount
                    </span>
                    <span>
                      <img src={AutomatedRecurringGifts} alt="Automated Recurring Gifts" width="126" height="126" />
                      Automated Recurring Gifts
                    </span>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="scalability"
                    role="tabpanel"
                    aria-labelledby="scalability-tab"
                  >
                    <h3 className="h1">Scalability and Flexibility</h3>
                    <p>
                      Our Nonprofit Management Software is built on Microsoft
                      Dynamics 365 which offers extensive additional
                      functionality over the core CRM packages, including events
                      management, publication distribution, powerful case
                      management extensions and a variety of user interface
                      improvements.
                    </p>
                    <p>By taking advantage of Microsoft’s scalability, you can leapfrog the various challenges faced by nonprofits and create processes that rival the industry's top players.</p>
                    <div className="ben-flex-div">
                    <span>
                      <img src={AutomatedApprovals} alt="Automated Approvals" width="126" height="126" />
                      Automated Approvals
                    </span>
                    <span>
                      <img src={SeamlessGiftGiving} alt="Seamless Gift Giving" width="126" height="126" />  
                      Seamless Gift Giving
                    </span>
                    <span>
                      <img src={PledgeManagement} alt="Pledge Management" width="126" height="126" />
                      Pledge Management
                    </span>
                    <span>
                      <img src={ReceiptsAcknowledgements} alt="Receipts & Acknowledgements" width="126" height="126" />
                      Receipts & Acknowledgements
                    </span>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="security"
                    role="tabpanel"
                    aria-labelledby="security-tab"
                  >
                    <h3 className="h1">Security </h3>
                    <p>
                      Right Cause is built on secure Microsoft Cloud, it is a
                      password protected web-based application that comes with
                      high-end user-based security roles and views. It contains
                      absolutely everything you need to manage your Fundraising,
                      Grants and associated activities.
                    </p>
                    <p>Keeping your donor and financial data safe and secure while providing flexible access.</p>
                    <div className="ben-flex-div">
                    <span>
                      <img src={AutomaticBackups} alt="Automatic Backups" width="126" height="126" />
                      Automatic Backups
                    </span>
                    <span>
                      <img src={HostedonAzure} alt="Hosted on Azure" width="126" height="126" />
                      Hosted on Azure
                    </span>
                    <span>
                      <img src={AuthorizedAccessValidation} alt="Authorized Access Validation" width="126" height="126" />
                      Authorized Access Validation
                    </span>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="compliance"
                    role="tabpanel"
                    aria-labelledby="compliance-tab"
                  >
                    <h3 className="h1">Compliance </h3>
                    <p>
                      Right Cause makes data more valuable and accessible by
                      addressing the gaps in complexities of each mission, the
                      nonprofit software solution is committed to creating a
                      more donor-focused digital ecosystem by providing
                      much-needed compliance with GDPR, HIPPA &amp; PIPEDA.{" "}
                    </p>
                    <div className="ben-flex-div">
                    <span>
                      <img src={gdpr} alt="Authorized Access Validation" width="126" height="126" />
                      Authorized Access Validation
                    </span>
                    <span>
                      <img src={HIPPA} alt="HIPPA" width="126" height="126" />
                      HIPPA
                    </span>
                    <span>
                      <img src={PIPEDA} alt="PIPEDA" width="126" height="126" />
                      PIPEDA
                    </span>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="accessibility"
                    role="tabpanel"
                    aria-labelledby="accessibility-tab"
                  >
                    <h3 className="h1">Accessibility </h3>
                    <p>
                      Right Cause can be accessed across different platforms,
                      giving you the option to utilize its functionality whether
                      you are sitting at your desk in the office, working
                      remotely, attending a fundraising event or visiting donors
                      overseas.
                    </p>
                    <p>
                    The Right Cause Nonprofit Software can be customized to make accessibility easy for all stakeholders, including those with disabilities. This will help ensure that everyone can participate in your nonprofit's activities and support your organization's mission.
                    </p>
                    <div className="ben-flex-div">
                      <span>
                        <img src={LevelBasedAccess} alt="Level-based Access" width="126" height="126" />
                        Level-based Access
                      </span>
                      <span>
                        <img src={DedicatedPortals} alt="Dedicated Portals" width="126" height="126" />
                        Dedicated Portals
                      </span>
                      <span>
                        <img src={DashboardAccessDepartment} alt="Dashboard Access for each Department" width="126" height="126" />
                        Dashboard Access for each Department
                      </span>
                      <span>
                        <img src={VolunteerAccess} alt="Volunteer Access" width="126" height="126" />
                        Volunteer Access
                      </span>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="shceduleDemo_div" className="shceduleDemo">
        <div className="container">
          <div className="row worriedabt_wrapper">
            <div className="col-md-12 col-lg-12">
              <div className="row align-items-center">
                <div className="col-md-6 col-lg-5">
                  <h2 className="h1">Worried about the pricing?</h2>
                  <p>
                    Microsoft offers discounts to charities. We’ll consult you
                    with all your licensing needs.
                  </p>
                  <a
                    onClick={() => AboutFunction("getStrated")}
                    className="rc-primary-btn rc-large-btn rc-btn mt-xl-3"
                    tabIndex="0"
                    aria-label="Request a call Button"
                  >
                    Request a call <i className="icon-arrow"></i>
                  </a>
                </div>
                <div className="col-md-6 col-lg-7">
                  <div className="worriedabtPeice_div">
                    <div className="worriedabtPeice_Icon">
                      <img src={prodigy} alt="own demands and expectations" width="69" height="69" />
                    </div>
                    <div className="worriedabtPeice_content">
                      <p>
                        They have embraced our vision and started learning our
                        business to deliver an application that has exceeded our
                        own demands and expectations. Throughout our
                        relationship, they have challenged us to think through
                        different solutions and worked tirelessly to ensure that
                        we always met our deadline.{" "}
                      </p>
                      <p>Paul A. Norkett, Chief Operating Officer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Fcontact policy={policy} />
      </Modal>
    </div>
  );
};

export default ReliabilitySecurity;
